export default __webpack_public_path__ + "static/media/logo.a69a970f.png";